export const isSortable = (obj: any) => {
  return obj && typeof obj === 'object' && obj['isSortable'] && obj['getComparator'];
}

export interface Sortable<T extends Sortable<T>> {
  isSortable: true;
  getComparator(): (a: T, b: T) => number;
}
